import {

  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
} from "@angular/core";
import { OneCommandTemplateComponent } from "src/components/template component/one-command-template/one-command-template.component";
import { TwoCommandsOneLabelTemplateComponent } from "src/components/template component/two-commands-one-label-template/two-commands-one-label-template.component";
import { TwoOrMoreButtonsTemplateComponent } from "src/components/template component/two-or-more-buttons-template/two-or-more-buttons-template.component";
import { MultipleRowsTemplateComponent } from "src/components/template component/multiple-rows-template/multiple-rows-template.component";
import { VirtualAccessTemplateComponent } from "src/components/template component/virtual-access-template/virtual-access-template.component";
import { ComponentAggregation } from "src/model/class/component classes/component-aggregation";
import { AggregationType } from "src/model/enum/enumCustomInterface";

/**
 * This directive generate only one custom interface aggregate entry.
 * It differs from custom-interface-placeholder because some element could be surranded by ion-reorder item.
 *
 */
@Directive({
    selector: "[appCustomInterfaceSingleComponentListPlaceholder]",
    standalone: false
})
export class CustomInterfaceSingleComponentListPlaceholderDirective {
  @Input("appCustomInterfaceSingleComponentListPlaceholder") set aggregate(
    aggregate: ComponentAggregation
  ) {
    this.drawCustomInterfaceAggregate(aggregate);
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef,
    
  ) {
    viewContainerRef.constructor.name === "ViewContainerRef_"; // true
  }

  /**
   * Draw single custom interface aggrage component
   *
   * @param aggregateComponent Aggregate original object to draw graphic element
   */
  private drawCustomInterfaceAggregate(
    aggregateComponent: ComponentAggregation
  ): void {
    const componentsHostViewRef = this.viewContainerRef;

    componentsHostViewRef.clear();

    const compFactory = this.getComponentFactoryByAggregateType(
      aggregateComponent.code
    );

    // if the component is recognized and the factory has been created we create the real component in the html and load into it the
    // relative API object with the command and state addresses
    if (compFactory != null) {
      const componentRef = componentsHostViewRef.createComponent(compFactory);
      (componentRef.instance as any).aggregate = aggregateComponent;
    }
  }

  /**
   * Get component factory by aggregation type
   *
   * @param aggregateType Input aggregation type
   * @returns Component factory
   */
  private getComponentFactoryByAggregateType(
    aggregateType: AggregationType
  ): any {
    let componentFactory: any = null;

    switch (aggregateType) {
      case AggregationType.ONE_COMMAND_TEMPLATE:
        componentFactory =
          this.viewContainerRef.createComponent(
            OneCommandTemplateComponent
          );
        break;
      case AggregationType.TWO_COMMAND_AND_LABEL_TEMPLATE:
        componentFactory =
          this.viewContainerRef.createComponent(
            TwoCommandsOneLabelTemplateComponent
          );
        break;
      case AggregationType.TWO_OR_MORE_COMMAND_TEMPLATE:
        componentFactory =
          this.viewContainerRef.createComponent(
            TwoOrMoreButtonsTemplateComponent
          );
        break;
      case AggregationType.MULTIPLE_ROWS_TEMPLATE:
        componentFactory =
          this.viewContainerRef.createComponent(
            MultipleRowsTemplateComponent
          );
        break;
      case AggregationType.VIRTUAL_ACCESS_TEMPLATE:
        componentFactory =
          this.viewContainerRef.createComponent(
            VirtualAccessTemplateComponent
          );
        break;
      default:
        break;
    }

    return componentFactory;
  }
}
